import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ExpensableMileage } from 'modules/expenses/hooks/useExpensable'

interface Props {
  mileage: ExpensableMileage | undefined | null
}

const MileageStatusCardContent = ({ mileage }: Props) => {
  const InterpolatedText = (text?: string | null) => (
    <span className="text-200 font-semibold">{text}</span>
  )

  const mileageValue = mileage?.mileage ?? 0
  const mileageCalculatedMileage = mileage?.calculatedMileage ?? 0

  const mileageFormatted = (mileageValue / 100)?.toString()
  const calculatedMileageFormatted = (mileageCalculatedMileage / 100)?.toString()
  const unitsFormatted = mileage?.units?.toLowerCase()

  return (
    <Box gap="s24" paddingX="s8" paddingBottom="s8">
      <Box gap="s8">
        <Box maxWidth="s400" gap="s16">
          <Text size="200">
            {i18n.tView('expenses_v2.forms.fields.mileage.alert.manually_changed.comparison', {
              calculated_mileage: InterpolatedText(calculatedMileageFormatted),
              mileage: InterpolatedText(mileageFormatted),
              units: InterpolatedText(unitsFormatted),
            })}
          </Text>
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text size="200">
              {i18n.tView('expenses_v2.forms.fields.mileage.alert.manually_changed.mileage', {
                value: InterpolatedText(mileageFormatted + ' ' + unitsFormatted),
              })}
            </Text>
            <Text size="200">
              {i18n.tView(
                'expenses_v2.forms.fields.mileage.alert.manually_changed.calculated_mileage',
                {
                  value: InterpolatedText(calculatedMileageFormatted + ' ' + unitsFormatted),
                }
              )}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default MileageStatusCardContent
